import { Injectable } from '@angular/core';
import { UserModel } from '../Models/UserModel';
import { MenuActionUserInsertModel } from '../../Menu/Models/MenuActionUserModel';
import { UserRoleInsertModel } from '../Models/UserRoleModel';
import { UserFirmInsertModel, UserFirmBranchInsertModel } from '../Models/FirmHierarcialModel';
import { ApiSendService } from '@global-services/ApiSend.service';
import { PaginationRequestModel } from '@global-models/Request/PaginationRequestModel';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { UserImageRequestModel } from '@global-models/Request/UserImageRequestModel';



@Injectable()
export class UserService {
  constructor(private _apiservice: ApiSendService) {
  }

  GetUsers(user: UserModel, pageModel: PaginationRequestModel, searchByFirm: string) {
    // tslint:disable-next-line:max-line-length
    return this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/User/GetUsers?OrderByName=' +
    pageModel.OrderByName + '&OrderByType=' + pageModel.OrderByType + '&Skip=' +
    pageModel.Skip + '&Take=' + pageModel.Take + '&Email=' + user.Email + '&Name=' + user.Name +
    '&LastName=' + user.LastName + '&SearchByFirm=' + searchByFirm);
  }

  RegisterUser(model: UserModel) {
    return this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/RegisterUser', model);
  }

  async DeleteUser(id: number) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/DeleteUser/?id=' + id, { id: id });
  }

  async UpdateUser(model: UserModel) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/UpdateUser', model);
  }

  async GetUser() {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/User/GetUser');
  }

  async ChangePassword(OldPassword: string, NewPassword: string, NewPasswordAgain: string) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/ChangePassword', {
      'OldPassword': OldPassword,
      'NewPassword': NewPassword,
      'NewPasswordAgain': NewPasswordAgain
    });
  }

  async FileUpload(model: UserImageRequestModel) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/UploadUserImage', model);
  }

  async getMenuActionUsers(userId: number) {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/Application/GetMenuActionUsers?userId=' + userId);
  }

  async saveMenuActionUsers(model: Array<MenuActionUserInsertModel>) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/Application/SaveMenuActionUsers', model);
  }

  async getUserRoles(userId: number) {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/Role/GetRolesByUser?userId=' + userId);
  }

  async saveUserRoles(model: Array<UserRoleInsertModel>) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/Role/SaveUserRoles', model);
  }

  async GetsFirmHierarcial(userId: number) {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/Firm/GetsFirmHierarcial?userId=' + userId);
  }

  async GetsBranchHierarcial(userId: number) {
    return await this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/Firm/GetsBranchHierarcial?userId=' + userId);
  }

  async saveUserFirms(model: Array<UserFirmInsertModel>) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/SaveUserFirms', model);
  }

  async SaveUserFirmBranches(model: Array<UserFirmBranchInsertModel>) {
    return await this._apiservice.PostAuthorization(ApiUrlEnum.BackOffice, '/api/User/SaveUserFirmBranches', model);
  }
}
